import { JSX } from 'react';
import { RouterProvider } from 'react-router-dom';

import { router } from 'src/router';

import { AuthProvider } from './AuthProvider';
import { QueryProvider } from './QueryProvider';

export function Providers(): JSX.Element {
  return (
    <AuthProvider>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </AuthProvider>
  );
}
